/**
 * Retrieves an integration object by a specified key and value.
 *
 * @param {String} key - The key to search by. Can be either 'code' or 'id'.
 * @param {String|Number} value - The value to match for the specified key.
 * @return {Object|undefined} - The matching integration object if found, or undefined if no match is found.
 * @throws {Error} - Throws an error if an unsupported key is provided.
 */
const getIntegration = ( key, value ) => {
	if ( ! [ 'code', 'id' ].includes( key ) ) {
		throw new Error( `Unsupported key: ${ key }. Use 'code' or 'id'.` );
	}

	return UncannyAutomatorBackend.templateLibrary.integrations.find(
		integration => integration[ key ] === value
	);
};

export default getIntegration;